import React from 'react'

import Content from '../components/Content'
import Button from '../components/Button'
import {banquet} from "../constant"
import Footer from '../components/Footer';
import Nav from '../components/Nav'
import conference from "../images/conference.png"
import master from "../images/banquet.jpg"
// import bg from "../images/IMG_0095.jpg"
// import reception from "../images/marrige_reception.JPG"
export const images=[conference,master,conference,master,conference]
const Banquet = () => {
  return (
    <div>
       
        <div className="h-3/4 bg bg-cover bg-center">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">BANQUET HALL</p>
          </div>
          </div>
          </div>
        {banquet.map((e,i)=>{
         if (i%2===0){
            return(
 <div key={i} className="container mx-auto bg-[#fff4f4] md:grid grid-rows-1 grid-cols-2 grid-flow-row flex flex-col">
<div className="text-black p-10 place-self-center">
            <Content isColor="black" title={e.title}
            subtitle={e.subtitle}
            content={e.content}/>
            <Button isColour={true} label='BOOK NOW'/>
          </div>
          <div className="bg-cover place-self-center">
            <img src={images[i]} alt="bg"/>
          </div>
          </div>
            )}
            else{
            return(
 <div key={i} className="container bg-[#fff4f4] mx-auto md:grid grid-rows-1 grid-cols-2 grid-flow-row flex flex-col-reverse">
<div className="bg-cover place-self-center">
            <img src={images[i]} alt="bg"/>
          </div>
          <div className="text-black p-10 place-self-center">
            <Content isColor="black" title={e.title}
            subtitle={e.subtitle}
            content={e.content}/>
            <Button isColour={true} label='BOOK NOW'/>
          </div>
          
          </div>)
            }
        })
    }
    <Footer/>
    </div>
  )
}

export default Banquet